import React from 'react';
import './home.scss';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate(); 

   const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <React.Fragment>
      <div className='grid grid-cols-4 gap-4 content-block'>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/order-manager')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Order Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Inventory Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Production Planner</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Process Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Grading Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Label Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Report Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>App 08</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Process Navigator</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Light Box</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Job Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
        <div className='dx-card responsive-paddings' onClick={() => handleCardClick('/tasks')} style={{cursor: 'pointer', transition: '0.5s'}}>
          <p className='opacity-75'>Lorem Ipsum</p>
          <div className='w-full flex items-center justify-between'>
            <h6 className='my-0'>Traceability Manager</h6>
            <span className="dx-badge">+2,6%</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
